import { styled } from "styled-components";
import { ToastVariant } from "./Toast";

export const Wrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]};
`;

export const IconWrapper = styled.div<{ $variant: ToastVariant }>`
  display: flex;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  color: ${({ theme, $variant }) =>
    ({
      success: theme.colors.icon.success,
      error: theme.colors.icon.error,
      info: theme.colors.icon.brand,
    })[$variant]};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.fonts.base.fontSize};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary.color};
`;

export const Description = styled.div`
  font-size: ${({ theme }) => theme.fonts.sm.fontSize};
  color: ${({ theme }) => theme.colors.text.secondary.color};
`;
